<template>
    <div>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" :title="dataEvent.title" :hide-footer="true" v-model="dataShow">
            <DynamicForm
                    v-if="dataValidEvents"
                    ref="dynamicForm"
                    :ignoreRouteParamId="ignoreRouteParamId"
                    v-model="dataId"
                    @onSave="onSave"
                    @onInitSuccess="onInitSuccess"
                    @onTrashClick="onTrashClick"
                    @onRequestSuccess="onRequestSuccess"
                    :getRoot="options.root.get"
                    :saveRoot="options.root.save"
                    :trashRoot="options.root.trash"
                    :formStructure="dataFormStructures.event">
                <slot slot="beforeForm">
                    <b-button v-if="Core.Validation.isId(dataId)" @click="onBackClick" class="btn btn-sm btn-light mb-3"><i class="fa fa-chevron-left mr-2"></i> {{Core.Definition.getDefinition('Retour')}}</b-button>
                </slot>
                <slot v-if="false" slot="afterForm">
                    <b-row v-if="Core.Validation.isId(dataId) && options.displayActions">
                        <b-col>
                            <b-button @click="$router.push(Core.Text.format(Core.Definition.getDefinition('/evenement/reservations/{0}/{1}'), dataDate, dataId))" class="btn btn-light mb-2"><i class="cui-user-follow mr-2"></i>{{Core.Definition.getDefinition('Voir les réservations')}}</b-button>
                            <b-button v-if="dataIsVirtual"  @click="$router.push(Core.Text.format(Core.Definition.getDefinition('/evenement/salles-virtuelles/{0}'), dataId))" class="btn btn-light ml-2 mb-2"><i class="fa fa-video-camera mr-2"></i>{{Core.Definition.getDefinition('Salle virtuelle')}}</b-button>
                            <hr/>
                        </b-col>
                    </b-row>
                </slot>
                <slot slot="reminder">
                    <Reminder :lg="12" v-model="dataReminder"></Reminder>
                </slot>
            </DynamicForm>
            <b-alert v-else show variant="warning">
                {{Core.Definition.getDefinition('Aucun événement à été créé. Vous devez créer un événement avant de pouvoir ajouter au calendrier.')}}
                <br/>
                <b-button class="btn btn-sm mt-3 btn-edit" @click="$router.push(Core.Definition.getDefinition('/evenement/evenements'))" type="button">{{Core.Definition.getDefinition('Créer des événements')}}</b-button>
            </b-alert>
        </b-modal>
    </div>

</template>

<script>
    var _self
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import MultipleUserBooking from './MultipleUserBooking'
    import DynamicForm from './DynamicForm'
    import ModalInstanceSelector from './ModalInstanceSelector'
    import Reminder from './Reminder'
    import Alert from './Alert'
    export default {
        name: 'ModalEventDate',
        components: {
            DynamicForm,
            ModalInstanceSelector,
            MultipleUserBooking,
            Reminder
        },
        props: {
            ignoreRouteParamId: {
                type: Boolean,
                default: false
            },
            seasonId: {
                type: String | Number,
                default: ''
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        format: {
                            value: 'YYYY-MM-DD',
                            label: 'dddd, DD MMMM YYYY',
                            startOf: 'isoWeek'
                        },
                        root: {
                            save: '/event-date',
                            get: '/event-date',
                            trash: '/event-date'
                        },
                        defaultValue: {
                            status: 'hidden'
                        },
                        displayActions: false
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(id) {
                    this.dataId = id
                },
                get() {
                    return this.dataId
                }
            },
            timeStart: {
                set(time) {
                    this.dataTimeStart = time
                },
                get() {
                    return this.dataTimeStart
                }
            },
            timeEnd: {
                set(time) {
                    this.dataTimeEnd = time
                },
                get() {
                    return this.dataTimeEnd
                }
            },
            date: {
                set(date) {
                    this.dataDate = date
                },
                get() {
                    return this.dataDate
                }
            },
            days: {
                set(days) {
                    this.dataDays = days
                },
                get() {
                    return this.dataDays
                }
            },
            event: {
                set(event) {
                    this.dataEvent = event
                },
                get() {
                    return this.dataEvent
                }
            }
        },
        watch: {
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataId: '',
                dataReminder: {
                    times: [],
                    model: {
                        option: Mantle.Reminder.modelSystemConfig,
                        text: ''
                    }
                },
                dataEventId: '',
                dataSeasonId: '',
                dataValidEvents: true,
                dataSaveAddArgs: [],
                dataShow: false,
                dataTimeStart: '',
                dataTimeEnd: '',
                dataDayOfWeek: '',
                dataDate: '',
                dataDays: 7,
                dataIsVirtual: false,
                dataAddress: [],
                dataEvent: {},
                dataFormStructures: {
                    event: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'eventId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'daysOfWeek'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'timeStart'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'timeEnd'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'assignedUsers'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'type'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'color'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'leagueId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'seasonId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'tag'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: 'Réservations',
                                                id:'booking',
                                                options: {
                                                    class: 'card-no-border card-no-margin-bottom',
                                                    collapse: true
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'waitingListIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'formTemplateId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'max'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingDateStart'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingTimeStart'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingDateEnd'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingTimeEnd'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: 'Produit',
                                                id:'product',
                                                options: {
                                                    class: 'card-no-border card-no-margin-bottom',
                                                    collapse: true
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'requiredProducts'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'forcePurchase'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: 'Rappels automatiques',
                                                id:'reminder',
                                                options: {
                                                    class: 'card-no-border card-no-margin-bottom',
                                                    collapse: true
                                                },
                                                key: 'reminder'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: 'Emplacement',
                                                id:'place',
                                                options: {
                                                    class: 'card-no-border card-no-margin-bottom',
                                                    collapse: true
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'addressId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'address'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'districtId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'local'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'cityId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'isVirtual',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Virtuel'),
                                value: null,
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.virtualEventIsEnabled'),'checkbox'),
                                onChange: function(val, form, fieldRefs) {
                                    if(val === true) {
                                        fieldRefs['max'].dataValue = 10
                                        fieldRefs['max'].dataReadOnly = true
                                        fieldRefs['min'].dataValue = 1
                                        fieldRefs['min'].dataReadOnly = true

                                        if (Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')) {
                                            fieldRefs['local'].isVisible = false
                                            fieldRefs['address'].isVisible = false
                                            fieldRefs['districtId'].isVisible = false
                                        }
                                    } else {
                                        fieldRefs['max'].dataReadOnly = false
                                        fieldRefs['min'].dataReadOnly = false

                                        if (Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')) {
                                            fieldRefs['local'].isVisible = true
                                            fieldRefs['address'].isVisible = true
                                            fieldRefs['districtId'].isVisible = true
                                        }
                                    }
                                }
                            },
                            {
                                id: 'type',
                                type: 'select',
                                label: Core.Definition.getDefinition('Type'),
                                value: null,
                                required: true,
                                onSelect: function() {}
                            },
                            {
                                id: 'eventId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Événement modèle'),
                                value: null,
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.data !== undefined) {
                                        _self.dataEventId = value.value
                                        if (!Core.Validation.isId(_self.dataId)) {

                                            let eventBookingTimeStart = value.data.bookingtimestart
                                            let eventBookingTimeEnd = value.data.bookingtimeend

                                            let eventDate = _self.date
                                            let eventTimeStart = _self.timeStart
                                            let eventDateStart =  eventDate + ' ' + eventTimeStart

                                            let bookingDateStart = ''
                                            let bookingTimeStart = ''

                                            let bookingDateEnd = eventDate
                                            let bookingTimeEnd =  Vue.moment(eventDateStart).format('HH:mm')

                                            if (!Core.Validation.isEmpty(eventBookingTimeStart)) {
                                                let eventBookingTimeStartHour = eventBookingTimeStart.split(':')[0]
                                                let eventBookingTimeStartMinute = eventTimeStart.split(':')[1]
                                                eventBookingTimeStartMinute = (eventBookingTimeStartHour * 60) + (eventBookingTimeStartMinute * 1)
                                                bookingTimeStart = Vue.moment(eventDateStart).subtract(eventBookingTimeStartMinute, 'minutes').format('HH:mm')
                                                bookingDateStart = Vue.moment(eventDateStart).subtract(eventBookingTimeStartMinute, 'minutes').format('YYYY-MM-DD')
                                            }

                                            if (!Core.Validation.isEmpty(eventBookingTimeEnd)) {
                                                let eventBookingTimeEndHour = eventBookingTimeEnd.split(':')[0]
                                                let eventBookingTimeEndMinute = eventBookingTimeEnd.split(':')[1]
                                                eventBookingTimeEndMinute = (eventBookingTimeEndHour * 60) + (eventBookingTimeEndMinute * 1)
                                                bookingTimeEnd = Vue.moment(eventDateStart).subtract(eventBookingTimeEndMinute, 'minutes').format('HH:mm')
                                                bookingDateEnd = Vue.moment(eventDateStart).subtract(eventBookingTimeEndMinute, 'minutes').format('YYYY-MM-DD')
                                            }

                                            fieldRefs['bookingTimeStart'].dataValue = bookingTimeStart
                                            fieldRefs['bookingTimeEnd'].dataValue = bookingTimeEnd
                                            fieldRefs['bookingDateStart'].dataValue = bookingDateStart
                                            fieldRefs['bookingDateEnd'].dataValue = bookingDateEnd

                                            fieldRefs['type'].dataValue = Core.Select.select(value.data.type, fieldRefs['type'].getOptions())
                                            fieldRefs['assignedUsers'].dataValue = Core.Value.encode(value.data.assignedUsers, 'multiSelect', fieldRefs['assignedUsers'].getOptions())
                                            fieldRefs['status'].dataValue = Core.Value.encode(value.data.status, 'select', fieldRefs['status'].getOptions())
                                            fieldRefs['requiredProducts'].dataValue = Core.Value.encode(value.data.requiredProducts, 'multiSelect', fieldRefs['requiredProducts'].getOptions())
                                            fieldRefs['forcePurchase'].dataValue = value.data.forcepurchase
                                            fieldRefs['title'].dataValue = value.data.title
                                            fieldRefs['description'].dataValue = value.data.description
                                            fieldRefs['color'].dataValue =  Core.Value.encode(value.data.color, 'color')

                                            fieldRefs['max'].dataValue = value.data.max
                                            fieldRefs['local'].dataValue = value.data.local
                                            fieldRefs['address'].dataValue = value.data.address

                                            fieldRefs['leagueId'].dataValue = Core.Value.encode(value.data.leagueid, 'multiSelect', fieldRefs['leagueId'].getOptions())
                                            fieldRefs['districtId'].dataValue = Core.Value.encode(value.data.districtid, 'select', fieldRefs['districtId'].getOptions())
                                            fieldRefs['cityId'].dataValue = Core.Value.encode(value.data.cityId, 'select', fieldRefs['cityId'].getOptions())
                                            fieldRefs['bookingIsEnabled'].dataValue = value.data.bookingisenabled
                                            fieldRefs['waitingListIsEnabled'].dataValue = value.data.waitinglistisenabled
                                            fieldRefs['formTemplateId'].dataValue = value.data.formTemplateId

                                            //fieldRefs['min'].dataValue = value.data.min
                                            //fieldRefs['isVirtual'].dataValue = value.data.isvirtual
                                            //fieldRefs['reminder'].dataValue = Core.Select.select(value.data.reminder, fieldRefs['reminder'].getOptions())

                                            _self.dataReminder = value.data.reminder
                                        }
                                    }
                                },
                                required: false
                            },
                            {
                                id: 'bookingIsEnabled',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Réservation autorisée'),
                                value: true,
                                onChange: function() {}
                            },
                            {
                                id: 'waitingListIsEnabled',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Liste d\'attente autorisée'),
                                value: true,
                                onChange: function() {}
                            },
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'requiredProducts',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Produits requis'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'formTemplateId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Formulaire'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'forcePurchase',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Forcer l\'achat lors de la réservation'),
                                description: Core.Definition.getDefinition(''),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'min',
                                type: 'quantity',
                                label: Core.Definition.getDefinition('Min.'),
                                value: '0'
                            },
                            {
                                id: 'max',
                                type: 'quantity',
                                label: Core.Definition.getDefinition('Max.'),
                                value: '0'
                            },
                            {
                                id: 'bookingDateStart',
                                type: 'date',
                                label: Core.Definition.getDefinition('Date d\'ouverture'),
                                value: ''
                            },
                            {
                                id: 'bookingDateEnd',
                                type: 'date',
                                label: Core.Definition.getDefinition('Date de fermeture'),
                                value: ''
                            },
                            {
                                id: 'bookingTimeStart',
                                type: 'time',
                                label: Core.Definition.getDefinition('Heure d\'ouverture'),
                                value: '',
                            },
                            {
                                id: 'bookingTimeEnd',
                                type: 'time',
                                label: Core.Definition.getDefinition('Heure de fermeture'),
                                value: '',
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'separator1',
                                type: 'separator'
                            },
                            {
                                id: 'assignedUsers',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Responsables'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'daysOfWeek',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Jour(s) de la semaine'),
                                value: null,
                                onSelect: function() {},
                                required: true
                            },
                            {
                                id: 'reminder',
                                type: 'select',
                                label: Core.Definition.getDefinition('Rappel automatique aux participants'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'separator1',
                                type: 'separator'
                            },
                            {
                                id: 'titleDate',
                                type: 'title'
                            },
                            {
                                id: 'timeStart',
                                type: 'time',
                                label: Core.Definition.getDefinition('Début'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'timeEnd',
                                type: 'time',
                                label: Core.Definition.getDefinition('Fin'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'color',
                                type: 'color',
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur'),
                                value: {}
                            },
                            {
                                id: 'status',
                                type: 'select',
                                description: Core.Definition.getDefinition('Un événement "Brouillon" ou "Privé" ne sera pas visible aux usagers. L\'action "Publier la semaine" remplace l\'état "Brouillon" par l\'état "Publié", pour tous les événements.'),
                                label: Core.Definition.getDefinition('État'),
                                value: Core.Select.select(this.options.defaultValue.status, Mantle.EventDate.getStatusOptions()),
                                onSelect: function() {},
                                required: true
                            },
                            {
                                id: 'local',
                                type: 'text',
                                label: Core.Definition.getDefinition('Local'),
                                value: ''
                            },
                            {
                                id: 'tag',
                                type: 'text',
                                label: Core.Definition.getDefinition('Tag'),
                                value: ''
                            },
                            {
                                id: 'districtId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Région'),
                                value: null,
                                onSelect: function() {},
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')
                            },
                            {
                                id: 'cityId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Ville'),
                                value: null,
                                onSelect: function() {},
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')
                            },
                            {
                                id: 'address',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                                value: '',
                                description: Core.Definition.getDefinition('Entrez une adresse valide pour la localisation Google Map (Format: Numéro, rue, ville, code postal)'),
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')
                            },
                            {
                                id: 'addressId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Adresses enregistrées'),
                                value: null,
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.data !== undefined) {
                                        fieldRefs['place'].dataValue = value.data.place
                                        fieldRefs['address'].dataValue = value.data.address
                                        fieldRefs['leagueId'].dataValue = Core.Value.encode(value.data.leagueid, 'select', fieldRefs['leagueId'].getOptions())
                                        fieldRefs['districtId'].dataValue = Core.Value.encode(value.data.districtid, 'select', fieldRefs['districtId'].getOptions())
                                    }
                                },
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')
                            },
                            {
                                id: 'seasonId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Saison'),
                                value: null,
                                onSelect: function() {},
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.seasonIsEnabled'),'checkbox')
                            },
                            {
                                id: 'leagueId',
                                type: Core.Value.typeMultiSelect,
                                label: Core.Definition.getDefinition('Ligue'),
                                value: null,
                                onSelect: function() {},
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.leagueIsEnabled'),'checkbox')
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onInitSuccess(data) {
                if(data.form !== undefined && data.form.reminder !== undefined) {
                    this.dataReminder = data.form.reminder
                }
            },
            onBackClick() {
                this.$emit('onBackClick')
            },
            addSaveArg(key, value, type) {
                this.dataSaveAddArgs.push({
                    key: key,
                    value: value,
                    type: type
                })
            },
            onSave() {
                this.$refs.dynamicForm.addSaveArg('reminder', this.dataReminder)
                for(let saveAddArg in this.dataSaveAddArgs) {
                    saveAddArg = this.dataSaveAddArgs[saveAddArg]
                    this.$refs.dynamicForm.addSaveArg(saveAddArg.key, saveAddArg.value, saveAddArg.type)
                }
                this.$emit('onSave')
            },
            onTrashClick(id) {
                this.$refs.dynamicForm.trash()
            },
            onRequestSuccess(data, method) {
                switch (method) {
                    case Core.Request.methodGet:

                        // Sélection d'un type par défaut pour éviter le blockage de la sauvegarde.
                        if (this.$refs.dynamicForm.$refs.form.fieldRefs['type'].dataValue === null) {
                            // Si aucune valeur pour le champs "Type" d'événement, sélection de la première option disponible.
                            let options =this.$refs.dynamicForm.$refs.form.fieldRefs['type'].getOptions()
                            if (options[0] !== undefined) {
                                this.$refs.dynamicForm.$refs.form.fieldRefs['type'].dataValue = Core.Select.select(options[0].value, options)
                            }
                        }

                        this.dataValidEvents = true
                        if (Core.Validation.isId(this.seasonId)&&data.selectOptions.seasonId!==undefined) {
                            this.$refs.dynamicForm.$refs.form.fieldRefs['seasonId'].dataValue = Core.Value.selectValue(this.seasonId, data.selectOptions.seasonId)
                        }

                        this.$refs.dynamicForm.$refs.form.fieldRefs['daysOfWeek'].setOptions(Core.Date.daysOfWeekOptions(this.dataDate, this.options.format.startOf, this.options.format.label, this.options.format.value, this.dataDays))
                        if (!Core.Validation.isId(this.dataId)) {
                            this.$refs.dynamicForm.$refs.form.fieldRefs['timeStart'].dataValue = this.dataTimeStart
                            this.$refs.dynamicForm.$refs.form.fieldRefs['timeEnd'].dataValue = this.dataTimeEnd
                            this.$refs.dynamicForm.$refs.form.fieldRefs['daysOfWeek'].dataValue = Core.Value.encode(Vue.moment(this.dataDate).format(this.options.format.value), 'multiSelect', Core.Date.daysOfWeekOptions(this.dataDate, this.options.format.startOf, this.options.format.label, this.options.format.value, this.dataDays))
                        }

                        this.dataIsVirtual = false
                        if (data.form !== undefined && data.form.isVirtual !== undefined) {
                            this.dataIsVirtual = Core.Value.encode(data.form.isVirtual, Core.Value.typeCheckbox)
                        }

                        break
                    case Core.Request.methodPost:
                    case Core.Request.methodPut:
                        this.$emit('onSaveSuccess', data, this.$refs.dynamicForm.$refs.form.fieldRefs)
                        if (data.id !== undefined) {
                            this.dataId = data.id
                        } else {
                            this.open = false
                        }
                        break
                    case Core.Request.methodDelete:
                        this.$emit('onTrashSuccess', data, this.$refs.dynamicForm.$refs.form.fieldRefs)
                        this.open = false
                        break
                }
            }
        }
    }
</script>
